export enum SizeType {
  Sm = 100,
  Md = 200,
  Lg = 300,
}